import type { OnboardingAssetRow } from "./OnboardingAssetTable";

/**
 * Assets created on the Onboarding tab during this page load.
 *
 * `GET /assets/` lists only what the caller's cached entitlements cover, so a
 * just-created asset is missing from it until Refresh entitlements (or the
 * hourly refresh) has run. The tab adds these rows back by hand. They live at
 * module level, not in the component, so they survive leaving Onboarding (sub-
 * or top-tab switches unmount it) and are dropped only by a page reload.
 * resetAssetLookup() does not touch them.
 */
let created: OnboardingAssetRow[] = [];

export const rememberCreatedAsset = (row: OnboardingAssetRow): void => {
  created = [...created.filter((a) => a.asset_id !== row.asset_id), row];
};

export const createdAssets = (): readonly OnboardingAssetRow[] => created;

export const wasCreatedHere = (assetId: number): boolean => created.some((a) => a.asset_id === assetId);

/** Tests only: the module outlives a single test. */
export const forgetCreatedAssets = (): void => {
  created = [];
};
